export default __webpack_public_path__ + "static/bar-with-labels-2db67dc528aded8f7db7d3102477170f.png";